import BaseAPIService from 'src/services/base/base-api-service';
import BillingAddressModel from 'src/model/billingAddress.model';

class AccountBillService extends BaseAPIService<BillingAddressModel> {
  public accountBillEndpoint: string = '/accountapp/v1/email';
  constructor() {
    super(BillingAddressModel);
  }

  public changeBillAddress(params: BillingAddressModel): Promise<any> {
    return this.create(
      `${this.accountBillEndpoint}/change/bill/address`,
      params
    );
  }
}

const accountBillServiceInstance = new AccountBillService();
Object.freeze(accountBillServiceInstance);

export default accountBillServiceInstance;
